module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraLight.4f3d2e0.ttf";